import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _applyDecoratedDescriptor from '@babel/runtime/helpers/esm/applyDecoratedDescriptor';
import { extension, keyBinding, NamedShortcut, command, MarkExtension, ExtensionTag, toggleMark, markInputRule, LEAF_NODE_REPLACING_CHARACTER } from '@remirror/core';
import { ExtensionCodeMessages } from '@remirror/messages';

var _dec, _dec2, _dec3, _class, _class2;
var DESCRIPTION = ExtensionCodeMessages.DESCRIPTION,
    LABEL = ExtensionCodeMessages.LABEL;
var toggleCodeOptions = {
  icon: 'codeLine',
  description: _ref => {
    var t = _ref.t;
    return t(DESCRIPTION);
  },
  label: _ref2 => {
    var t = _ref2.t;
    return t(LABEL);
  }
};
/**
 * Add a `code` mark to the editor. This is used to mark inline text as a code
 * snippet.
 */

var CodeExtension = (_dec = extension({}), _dec2 = keyBinding({
  shortcut: NamedShortcut.Code,
  command: 'toggleCode'
}), _dec3 = command(toggleCodeOptions), _dec(_class = (_class2 = class CodeExtension extends MarkExtension {
  get name() {
    return 'code';
  }

  createTags() {
    return [ExtensionTag.Code, ExtensionTag.ExcludeInputRules];
  }

  createMarkSpec(extra, override) {
    var _override$parseDOM;

    return _objectSpread(_objectSpread({
      excludes: '_'
    }, override), {}, {
      attrs: extra.defaults(),
      parseDOM: [{
        tag: 'code',
        getAttrs: extra.parse
      }, ...((_override$parseDOM = override.parseDOM) !== null && _override$parseDOM !== void 0 ? _override$parseDOM : [])],
      toDOM: mark => ['code', _objectSpread({
        spellcheck: 'false'
      }, extra.dom(mark)), 0]
    });
  }

  createKeymap() {
    return {
      'Mod-`': toggleMark({
        type: this.type
      })
    };
  }

  keyboardShortcut(props) {
    return this.toggleCode()(props);
  }
  /**
   * Toggle the current selection as a code mark.
   */


  toggleCode() {
    return toggleMark({
      type: this.type
    });
  }

  createInputRules() {
    return [markInputRule({
      regexp: new RegExp("(?:`)([^`".concat(LEAF_NODE_REPLACING_CHARACTER, "]+)(?:`)$")),
      type: this.type,
      ignoreWhitespace: true
    })];
  }

  createPasteRules() {
    return [{
      type: 'mark',
      regexp: /`([^`]+)`/g,
      markType: this.type
    }];
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "keyboardShortcut", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "keyboardShortcut"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleCode", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleCode"), _class2.prototype)), _class2)) || _class);

export { CodeExtension };
